import './index.css'
import 'react-toastify/dist/ReactToastify.css'

import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import i18n from '../i18n'
import { DesignFormProvider } from './providers/DesignFormProvider'
import AppRoutes from './routes'
import { store } from './store'




function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <BrowserRouter basename='/admin'>
          <DesignFormProvider>
            <ToastContainer autoClose={2000} />
            <AppRoutes />
          </DesignFormProvider>
        </BrowserRouter>
      </Provider>
    </I18nextProvider>
  )
}

export default App
